import { render } from "./HeroiconsOutlineTruck.vue?vue&type=template&id=5335d8e0"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineTruck.vue"]])

export default __exports__